import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

export enum FiChecklistViewerSnackbarColorClass {
    Standard = 'snackbar-color-standard',
    Error = 'snackbar-color-error',
    Warning = 'snackbar-color-warning',
}

@Component({
    selector: 'fi-checklist2-viewer-disabled-viewer-warning-snackbar',
    template: `
        <div class="snackbar-wrapper" [class]="snackbarColorClass">
          <mat-icon class="snackbar-icon" [ngClass]="iconClass"></mat-icon>
          <span class="snackbar-label" [innerHTML]="textMessage"> </span>
          @if (isClickable) {
            <span class="snackbar-label snackbar-action-label clickable" (click)="snackbarClick()">
              {{ actionMessage }}
            </span>
          }
        </div>
        `,
    styleUrls: ['./disabled-viewer-warning-snackbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-viewer-disabled-viewer-warning-snackbar' },
    standalone: false,
})
export class FiChecklist2ViewerDisabledViewerWarningSnackbarComponent {
    @Input() iconClass: string;
    @Input() textMessage: string;
    @Input() actionMessage: string;
    @Input() isClickable: boolean;
    @Input() snackbarColorClass: FiChecklistViewerSnackbarColorClass;

    @Output() onSnackbarClick = new EventEmitter<void>();

    snackbarClick() {
        this.onSnackbarClick.emit();
    }
}
